import {AnyAction, bindActionCreators} from 'redux';
import {withToastManager} from 'react-toast-notifications';
import {connect} from 'react-redux';
import {notificationsReducerKey} from '../redux/types';
import {State} from '../../../redux/reducer';
import {ThunkDispatch} from 'redux-thunk';
import Notifications from './Notifications';
import * as actions from '../redux/actions';
import {layoutActions} from 'features/layout/redux';

const mapStateToProps = (state: State) => ({
   toasts: state[notificationsReducerKey].toasts,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>) => ({
   onClose: bindActionCreators(actions.closeToast, dispatch),
   openSubDialog: bindActionCreators(layoutActions.openSubDialog, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(Notifications));
